import { t } from '@lingui/core/macro';
import { AccordionItemElement, Chip, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useActiveDocument } from 'shared/domains/documents';
export function DocumentItem(props) {
    const { id, name, deleted } = props;
    const { id: activeDocumentId } = useActiveDocument();
    const history = useHistory();
    const isActiveDocument = id === activeDocumentId;
    const getDocumentSubtitle = () => {
        if (isActiveDocument) {
            return t({
                message: 'This document',
                comment: 'Document settings - Projects list item subtitle (current document)',
            });
        }
        return undefined;
    };
    const goToDocument = () => {
        history.push(`/document/${id}`);
    };
    const getEndElement = () => {
        if (deleted) {
            return (<Tooltip title={t({
                    message: 'This document has been deleted from Pocketlaw',
                    comment: 'Tooltip for deleted document',
                })}>
          <Chip size="small" appearance="danger" icon={<Falcon icon="circle-info"/>} label={t({ message: 'Deleted', comment: 'Label for deleted document' })}/>
        </Tooltip>);
        }
        return undefined;
    };
    return (<AccordionItemElement title={name} icon={<Falcon icon="file"/>} subtitle={getDocumentSubtitle()} endElement={getEndElement()} onClick={deleted ? undefined : goToDocument}/>);
}
